/** Тип формы. */
export enum FormType {
    /** Клиент. */
    Client = "client",

    /** Раздел информации о заявке. */
    OrderInfo = "order-info",

    /** Раздел информации об устройстве в заявке. */
    OrderProduct = "order-product",

    /** Раздел информации об оплате в заявке. */
    OrderPayment = "order-payment",

    Order = "order",
    Sale = "sale",
    Good = "good",
    Transaction = "transaction",
}
